export const licenseKey =
	"ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjg5ZTNmZDU1LWNmOWEtNDEwMi1hYzE5LWZiMjUxOTllMGFkNCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.eP8M7ueCBj5HdTbX61DN27SrEHo1kX8Gu2IzwkJJISu6LTpgRgyDOgC7shlIdwNsA8Y+SSK+QlYQSkLlRbzD0WKrt9uN2yglDqHcAE5187aUcb/Cp2AdKgMQEzbXqDeWINTPWA==";
